<script setup lang="ts"></script>

<template>
    <div :class="['w-full', $route.meta.fullscreen ? 'h-screen overflow-hidden' : 'min-h-screen']">
        <div class="mx-auto">
            <slot />
        </div>
    </div>
</template>
